import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { BrandTheme } from '../config/theme.config'

interface UIState {
  mode: 'light' | 'dark'
  brandTheme: BrandTheme
  theme: 'light' | 'dark' // 遗留保留，避免断崖式报错，后续可全面移除
  sidebarCollapsed: boolean
  language: string
  notifications: Array<{ id: string; message: string; type: 'info' | 'warning' | 'error' }>
  setMode: (mode: 'light' | 'dark') => void
  setBrandTheme: (theme: BrandTheme) => void
  setTheme: (theme: 'light' | 'dark') => void // 遗留
  toggleSidebar: () => void
  setLanguage: (language: string) => void
  addNotification: (notification: { message: string; type: 'info' | 'warning' | 'error' }) => void
  removeNotification: (id: string) => void
  clearNotifications: () => void
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      mode: 'light',
      brandTheme: 'indigo',
      theme: 'light',
      sidebarCollapsed: false,
      language: 'zh-CN',
      notifications: [],
      setMode: (mode) => set({ mode, theme: mode }),
      setBrandTheme: (brandTheme) => set({ brandTheme }),
      setTheme: (theme) => set({ theme, mode: theme }),
      toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setLanguage: (language) => set({ language }),
      addNotification: (notification) => set((state) => ({
        notifications: [...state.notifications, { id: Date.now().toString(), ...notification }]
      })),
      removeNotification: (id) => set((state) => ({
        notifications: state.notifications.filter((n) => n.id !== id)
      })),
      clearNotifications: () => set({ notifications: [] }),
    }),
    {
      name: 'ui-storage', // 开启持久化
      partialize: (state) => ({ mode: state.mode, brandTheme: state.brandTheme, language: state.language, sidebarCollapsed: state.sidebarCollapsed }), // 仅持久化这些字段
    }
  )
)